import { createFileRoute } from "@tanstack/react-router"
import { validateAdminAvatarsSearch } from "~/components/AvatarReview/avatarAdminSearch"
import { AdminAvatarsRoute } from "./-AvatarsPage"

export const Route = createFileRoute("/admin/avatars")({
  validateSearch: validateAdminAvatarsSearch,
  component: AdminAvatarsRoute,
})
